<!-- TEMPLATE CONTRACT: Ui Page Tabs Header Component owns the visible Angular template structure for src/app/shared/ui/ui-page-tabs-header/ui-page-tabs-header.component.html. -->
<section class="ui-page-tabs-header">
  <div class="ui-page-tabs-header__intro">
    <h1 class="ui-page-tabs-header__title">{{ title() | uiLabelTranslate }}</h1>
    <!-- Conditional branch documents the visible UI state for this condition. -->
    @if (description()) {
      <p class="ui-page-tabs-header__description">{{ description() | uiLabelTranslate }}</p>
    }
  </div>

  <!-- Conditional branch documents the visible UI state for this condition. -->
  @if (tabs().length > 0) {
    <div class="ui-page-tabs-header__tabs-row">
      <!-- Toolbar/filter section for narrowing visible data. -->
      <ui-filter-bar [filters]="tabs()" [selected]="activeTab()" (changed)="onTabSelected($event)"></ui-filter-bar>
      <ng-content select="[tabsActions]" />
    </div>
  }
</section>
